import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPROMOSELECTPRODUCTBLOCK_LEGACY_FIELD_ORDER = [
  "primary_button_background_color",
  "primary_button_text_color",
  { type: 'separator' },
  "secondary_button_background_color",
  "secondary_button_text_color",
  { type: 'separator' },
  "background_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskPromoSelectProductBlockDescriptor: _generatedKioskPromoSelectProductBlockDescriptor,
  kioskPromoSelectProductBlockBlocDefinition,
  kioskPromoSelectProductBlockDashboardLayout,
  kioskPromoSelectProductBlockConfig,
  kioskPromoSelectProductBlockResolveConfig,
  kioskPromoSelectProductBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Promo Select Product",
    componentType: 'KioskPromoSelectProductBlockComponent',
    category: 'kiosk',
    description: "Kiosk - Promo Select Product.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskPromoSelectProductPageComponent', slot: 'body' },
    ],


    sharedFields: {}
  },

  () => ({
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.secondary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-500"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-500"},
      options: {
        label: "pages.blocks.kiosk-promo-select-product.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-promo-select-product.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-promo-select-product.fieldset.page.label",
            fields: ["background_color", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-promo-select-product.fieldset.primary-button.label",
            fields: ["primary_button_background_color", "primary_button_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-promo-select-product.fieldset.secondary-button.label",
            fields: ["secondary_button_background_color", "secondary_button_text_color"],
          },
        ],
      },
    ],
  })
);

export function kioskPromoSelectProductBlockDescriptor(): IBlockDescriptor;
export function kioskPromoSelectProductBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskPromoSelectProductBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskPromoSelectProductBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskPromoSelectProductBlockDescriptor, kioskPromoSelectProductBlockProperties, fieldOrder);
}

export {
  kioskPromoSelectProductBlockBlocDefinition,
  kioskPromoSelectProductBlockDashboardLayout,
  kioskPromoSelectProductBlockProperties,
  kioskPromoSelectProductBlockConfig,
  kioskPromoSelectProductBlockResolveConfig,
};

export type KioskPromoSelectProductBlockConfig = typeof kioskPromoSelectProductBlockConfig;
